/**
 * #19934 — một lịch hẹn có thể mang HAI loại số thứ tự, và màn hình phải nói đó là số nào.
 *
 * - **STT vào phòng** (`roomNo`): lịch đã có phòng, bệnh nhân đến thẳng phòng.
 * - **STT quầy tiếp đón** (`registrationNo`): lịch đặt không phòng, bệnh nhân đến quầy để lễ tân chỉ
 *   định phòng. Lễ tân xếp phòng sau thì bệnh nhân giữ số quầy và nhận thêm số vào phòng.
 */
export interface SttSource {
  roomId?: string | null;
  roomNo?: number | null;
  registrationNo?: number | null;
}

/** Lịch đặt vào quầy tiếp đón: chưa có phòng. */
export function isCounterBooking(a: SttSource): boolean {
  return !a.roomId;
}

export interface SttRow {
  label: string;
  value: number | null;
}

/** Các dòng STT cho màn chi tiết. Dòng đầu là số chính (bệnh nhân cầm số đó). */
export function sttRows(a: SttSource): SttRow[] {
  const rows: SttRow[] = [];
  if (a.roomNo != null) rows.push({ label: "STT vào phòng", value: a.roomNo });
  if (a.registrationNo != null) {
    rows.push({ label: "STT quầy tiếp đón", value: a.registrationNo });
  }
  if (rows.length === 0) rows.push({ label: "STT", value: null });
  return rows;
}

/**
 * Số ngắn cho danh sách / lịch: "5" hoặc "—". Số chính là STT vào phòng; lịch quầy dùng STT quầy.
 * CHỈ con số — nơi tiếp nhận (Quầy/Phòng) do {@link sttPlace} nói, màn hình đặt nó ở cột/nhãn
 * riêng chứ không ghép vào số (yêu cầu 30/10: cột "STT quầy" chỉ in số, khối lịch tuần in
 * "STT 3 · 09:00 Long" và nhãn Quầy/Phòng canh phải).
 */
export function sttShort(a: SttSource): string {
  if (a.roomNo != null) return String(a.roomNo);
  if (a.registrationNo != null) return String(a.registrationNo);
  return "—";
}

/** Nơi tiếp nhận của lịch: "Quầy" (chưa có phòng) hoặc "Phòng". */
export function sttPlace(a: SttSource): "Quầy" | "Phòng" {
  return isCounterBooking(a) ? "Quầy" : "Phòng";
}

/** Nhãn đầy đủ cho chú thích: "STT 5", "STT quầy 2" hoặc "STT —". */
export function sttTitle(a: SttSource): string {
  if (a.roomNo != null) return `STT ${a.roomNo}`;
  if (a.registrationNo != null) return `STT quầy ${a.registrationNo}`;
  return "STT —";
}
